import { render, staticRenderFns } from "./ModalShare.vue?vue&type=template&id=9ca35ac6&scoped=true"
import script from "./ModalShare.vue?vue&type=script&lang=js"
export * from "./ModalShare.vue?vue&type=script&lang=js"
import style0 from "./ModalShare.vue?vue&type=style&index=0&id=9ca35ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca35ac6",
  null
  
)

export default component.exports